import {
  GET,
  POST,
} from "../../apiController";

const endpoint = "/admin/permissions";

// --------------------------------------- roles and permissions 

// /get_full_module_hierarchy
export const getFullModulegetFullModuleHierarchyWithActionsHierarchy = () => {
  return GET(endpoint + `/permissions/hierarchy`);
};

// updateRolePermission 
export const updateRolePermission = (data) => {
  return POST(endpoint + `/permissions/update`, data);
};

//insertRoleAndPermissions
export const insertRoleAndPermissions = (data) => {
  return POST(endpoint + `/permissions/create`, data);
};

// deleteRoleAndPermissions
export const deleteRoleAndPermissions = (data) => {
  return POST(endpoint + `/permissions/delete`, data);
};
